import React from "react";
import { ConsoleStaticDataContextType } from "./type";
import { useGetCommunicationDTOMap } from "./dataloader";
import { isEmpty } from "shared/utils";

const ConsoleStaticDataContext = React.createContext<ConsoleStaticDataContextType>({} as ConsoleStaticDataContextType);

export function ConsoleStaticDataContextProvider(props: React.PropsWithChildren<{}>) {
  const { data: communicationDto = {} } = useGetCommunicationDTOMap();

  const values: ConsoleStaticDataContextType = React.useMemo(() => {
    return { communicationDto: communicationDto };
  }, [communicationDto]);

  return <ConsoleStaticDataContext.Provider value={values} {...props} />;
}

export function useConsoleStaticData() {
  const context = React.useContext(ConsoleStaticDataContext);
  if (isEmpty(context)) {
    throw new Error("useConsoleStaticData must be used within a ConsoleStaticDataContextProvider");
  }
  return context;
}
